import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { arrayPush } from 'redux-form';
import { Modal, Button } from 'react-bootstrap';
import { fetchAddress, openModal, closeModal } from '../../actions';
import Spinner from './spinner';

import '../../css/sendmail.css';

class RenderFieldNotification extends Component {
  constructor() {
    super();
    this.text_truncate = this.text_truncate.bind(this);
    this.handleAddTo = this.handleAddTo.bind(this);
    this.handleAddCc = this.handleAddCc.bind(this);
  }

  componentDidMount() {
    const { label, CNeeID, fetchAddress } = this.props;
    // Fetch contacts on mount if we have a consignee ID and this is To/Cc
    if ((label === 'To:' || label === 'Cc:') && CNeeID) {
      fetchAddress(CNeeID);
    }
  }

  text_truncate(str, length = 100, ending = '...') {
    if (!str) return '';
    return str.length > length ? str.substring(0, length - ending.length) + ending : str;
  }

  handleAddTo(email) {
    const safe = (email || '').toString().trim();
    if (!safe) return;
    this.props.arrayPush('SendNotification', 'to', safe);
  }

  handleAddCc(email) {
    const safe = (email || '').toString().trim();
    if (!safe) return;
    this.props.arrayPush('SendNotification', 'cc', safe);
  }

  render() {
    const {
      // defaults keep the field rendering even while loading
      addressBook = [],
      addressBookLoading = false,
      addressBookError = null,

      CNeeName = '',
      CNeeID,
      label = '',
      type = 'text',
      input = { value: '', onChange: () => {} },
      disabled = false,
      showModal = false,
      openModal,
      closeModal,
      meta = {}
    } = this.props;

    const { error, touched } = meta;

    // Always feed a string to the input (join arrays if present)
    const rawValue = input.value;
    const displayValue = Array.isArray(rawValue)
      ? rawValue.join(', ')
      : (rawValue == null ? '' : String(rawValue));

    // Normalize contact items (accept Email/email + Name/name); filter entries without email
    const items = Array.isArray(addressBook)
      ? addressBook
          .map(x => {
            if (!x) return null;
            const email = (x.Email || x.email || '').toString().trim();
            const name  = (x.Name  || x.name  || email);
            return email ? { email, name } : null;
          })
          .filter(Boolean)
      : [];

    const handleOpenModal = () => {
      // If we didn't have CNeeID at mount, fetch on first open
      if ((label === 'To:' || label === 'Cc:') && CNeeID && !addressBookLoading && addressBook.length === 0) {
        this.props.fetchAddress(CNeeID);
      }
      openModal();
    };

    return (
      <div>
        {/* Address Book Modal */}
        <Modal bsSize="large" show={showModal} onHide={closeModal}>
          <Modal.Header closeButton>
            <Modal.Title>
              <div className="container">Address Book: {CNeeName}</div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="container">
              {addressBookLoading ? (
                <Spinner />
              ) : addressBookError ? (
                <div className="text-danger">Failed to load contacts.</div>
              ) : items.length === 0 ? (
                <div className="text-muted">No contacts found for this consignee.</div>
              ) : (
                <>
                  <h3>To:</h3>
                  <div className="row">
                    {items.map((item, index) => (
                      <div className="col-sm-4 col-xs-6" key={`to-${index}`}>
                        <div
                          onClick={() => this.handleAddTo(item.email)}
                          className="btn btn-default btn-xs"
                        >
                          {this.text_truncate(item.name, 24)}
                        </div>
                      </div>
                    ))}
                  </div>

                  <h3>Cc:</h3>
                  <div className="row">
                    {items.map((item, index) => (
                      <div className="col-sm-4 col-xs-6" key={`cc-${index}`}>
                        <div
                          onClick={() => this.handleAddCc(item.email)}
                          className="btn btn-default btn-xs"
                        >
                          {this.text_truncate(item.name, 24)}
                        </div>
                      </div>
                    ))}
                  </div>
                </>
              )}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={closeModal}>Close</Button>
          </Modal.Footer>
        </Modal>

        {/* Field UI (always rendered) */}
        <div className="form-group form-group-sm">
          <div className="row">
            <div className="col-sm-3">
              <label>
                {label}
                <span onClick={handleOpenModal} style={{ marginLeft: 6, cursor: 'pointer' }}>
                  {(label === 'To:' || label === 'Cc:') ? (
                    <i className="fa fa-address-book-o fa-lg" aria-hidden="true" />
                  ) : null}
                </span>
              </label>
            </div>
            <div className="col-sm-9">
              <input
                className="form-control"
                type={type}
                {...input}
                value={displayValue}
                disabled={disabled}
              />
              {(label === 'To:' || label === 'Cc:') ? (
                <div className="text-info">
                  For multiple emails separate with comma or semicolon
                </div>
              ) : null}
              {touched && error && <span className="text-danger">{error}</span>}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps({ util }) {
  return {
    showModal: util?.showModal ?? false,
    addressBook: util?.addressBook ?? [],
    addressBookLoading: util?.addressBookLoading ?? false,
    addressBookError: util?.addressBookError ?? null
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ fetchAddress, openModal, closeModal, arrayPush }, dispatch);
}

RenderFieldNotification = connect(
  mapStateToProps,
  mapDispatchToProps
)(RenderFieldNotification);

export default RenderFieldNotification;